import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import rootStores from "../../stores";

const RFIDTicketsStore = rootStores.RFIDTicketsStore;

const dateFormat = (params: any) => moment(params.value).format("DD/MM/YYYY");

export const getColumns = (language: "he" | "en"): GridColDef[] => {
  const isLTR = language === "en";

  return [
    {
      field: "OID",
      headerName: language === "he" ? "מספר הזמנה" : "Order No.",
      align: isLTR ? "left" : "right",
      headerAlign: isLTR ? "left" : "right",
    },
    {
      field: "CustNr",
      headerName: language === "he" ? "מספר לקוח" : "Member ID",
      align: isLTR ? "left" : "right",
      headerAlign: isLTR ? "left" : "right",
    },
    {
      field: "Row",
      headerName: language === "he" ? "שורה" : "Row",
      align: isLTR ? "left" : "right",
      headerAlign: isLTR ? "left" : "right",
    },
    {
      field: "Seat",
      headerName: language === "he" ? "כסא" : "Seat",
      align: isLTR ? "left" : "right",
      headerAlign: isLTR ? "left" : "right",
    },
    {
      field: "AreaText",
      headerName: language === "he" ? "איזור" : "Area",
      align: isLTR ? "left" : "right",
      headerAlign: isLTR ? "left" : "right",
      valueFormatter: (params) => {
        const area = RFIDTicketsStore.areas?.find(
          (area: any) => area.areaKey === params.value
        );
        return area?.name ?? params.value ?? "";
      },
    },
    {
      field: "BC",
      headerName: language === "he" ? "ברקוד" : "Barcode",
      width: 220,
      align: isLTR ? "left" : "right",
      headerAlign: isLTR ? "left" : "right",
    },
  ];
};
